<template>
	<div>
			<!--header-->
			<TopAppBar
				leftBtnMode="arrow_back"
				:rightBtnMode="rightBtnMode"
				:title= "brandName"
				:leftBtnMethod="confirmOnCancel"
				:rightBtnMethod="rightBtnMethod"
				:staticMode="true"
			>
			</TopAppBar>
			<!--header ends-->
	<div class="d-flex h-full flex-column">
			<TopAppBarDrawer></TopAppBarDrawer>
		<main class="main-wrapper flex-grow-1">
						<div class="d-flex align-items-center bg-white">
							<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
								{{this.$t('1336')}}
							</div>
			</div>
			<div class="divider"></div>
				<div class="container container--narrow mgt-50">
					<img :src="licenseData.licenseMember.file.resourceUri ? licenseData.licenseMember.file.resourceUri : '/images/license-crop-image.png'" alt=""
						v-if="!cropperVisible"
						@click="showFileChooser()" @keypress="showFileChooser()" tabindex="0"
					>
					<vue-cropper
						ref="cropper"
						:src="cropImg"
						alt="Source Image"
						:cropmove="cropImage"
						:autoCropArea="1"
						v-if="cropperVisible"
						class="cropper"
					>
					</vue-cropper>
					<input
						ref="input"
						type="file"
						name="image"
						accept="image/*"
						@change="setImage"
						class="d-none"
					/>
					<div class="mgt-50">
									<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" @click="saveImage()" @keypress="saveImage()" tabindex="0">
													<div class="mdc-button__ripple"></div>
													<span class="mdc-button__label t-body2 font-r">{{ $t('1337') }}</span>
									</button>
									<button class="mdc-button bg-white t-color-secondaryBtnText  b-radius4" @click="confirmOnCancel" @keypress="confirmOnCancel" tabindex="0">
													<div class="mdc-button__ripple"></div>
													<span class="mdc-button__label t-body2 font-r">{{$t('1613')}}</span>
									</button>
					</div>
	</div>
</main>
			<!--add form ends-->
		</div>
		<!--add screen ends-->
    </div>
</template>

<script>
// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue';
import {topAppBarMixin} from '@/mixins/topAppBar.js';
import {joinMixin} from '@/mixins/join.js';
import VueCropper from 'vue-cropperjs';
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import httpService from "@/api/httpService.js";
import licenseApi from "@/api/licenseApi.js";
import memberApi from "@/api/memberApi.js";

export default {
	components: {
		VueCropper,
		TopAppBar,
		TopAppBarDrawer
	},
	mixins: [topAppBarMixin, joinMixin],
	data() {
		return {
		memberId: null,
		licenseData : {
			licenseMember: {
				file: {
					resourceUri: null
				}
			}
		},
		brandName : localStorage.getItem('brandName'),
		issueDate: null,
		expiryDate: null,
		cropImg: '',
		cropperVisible: false,
		licenseName: null,
		licenseId: null
		};
	},
	mounted() {
		memberApi.getMemberInfo().then((response) => {
			this.memberId = response.data.data.id;
			let params = {
				memberId: this.memberId
			};
			this.getLicenseInfo(params);
		}).catch((err) => {
			console.log(err);
		});
	},
	methods: {
		// 		openForm() {
		// 	this.crop = false;
		// },
		confirmOnCancel(){
			this.$confirm({
				title: this.$t("1339"),
				content:this.$t("1340"),
				accept: this.$t("1342"),
				cancel: this.$t("1341"),
			})
			.then(() => {
				this.$router.push('/licenseModify');
			})
			.catch(() => {});
		},
		getLicenseInfo(params) {

			this.cropImg = '';
			this.cropperVisible = false;

			licenseApi.getMemberLicenseDetails(params).then((response) => { 
				this.licenseData = response.data.data;
				this.licenseName = response.data.data.licenseResponsibility.name;
				this.licenseId = response.data.data.licenseMember.id;
				this.issueDate = response.data.data.licenseMember.issueDate;
				this.expiryDate = response.data.data.licenseMember.expiryDate;
			}).catch((err) => {
				console.log(err);
			});
		},
		showFileChooser() {
			this.$refs.input.click();
		},
		setImage(e) {
			this.cropperVisible = true
			const file = e.target.files[0];
			if (file.type.indexOf('image/') === -1) {
				console.log("Not a image file");
				return;
			}
			if (typeof FileReader === 'function') {
				const reader = new FileReader();
				reader.onload = (event) => {
				this.imgSrc = event.target.result;
				// rebuild cropperjs with the updated source
				this.$refs.cropper.replace(event.target.result);
				};
				reader.readAsDataURL(file);
			} else {
				console.log('Sorry, FileReader API not supported');
			}
		},
		cropImage() {
			this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
		},
		dataURItoBlob(dataURI) {
			// convert base64/URLEncoded data component to raw binary data held in a string
			let byteString
			if (dataURI.split(',')[0].indexOf('base64') >= 0){
				byteString = atob(dataURI.split(',')[1])
			}else {
				byteString = unescape(dataURI.split(',')[1])
			}

			// separate out the mime component
			let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

			// write the bytes of the string to a typed array
			let ia = new Uint8Array(byteString.length);
			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}

			return new Blob([ia], {type:mimeString});
		},
		saveImage() {
			if (typeof this.$refs.cropper != 'undefined' && this.$refs.cropper) {
				this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
		   
				let blob = this.dataURItoBlob(this.cropImg);

				let formData = new FormData();
				formData.append('file', blob, 'license.png');
				httpService.upload(formData).then((response) => {
					// let params = {
					//     issueDate: this.issueDate,
					//     expiryDate: this.expiryDate,
					//     file: response.data.data[0]
					// }

					let params = {
						file: response.data.data[0]
					}
					localStorage.setItem("licenseImage", JSON.stringify(params));
					this.$router.push('/licenseModify');
					// licenseApi.updateLicense(this.licenseId, params).then((response)=>{
					//     this.$router.push('/licenseModify');
					// })
				})
				.catch((err) => {
					console.log(err);
				});
			} else {
				this.$router.push('/licenseModify');
			}
		}
	}
};
</script>

<style scoped>
	/* specific for this screen only */
	.bg-red {
		background-color: var(--secondaryBtnText)  !important;	
	}
	.t-color-red1{
		color: var(--Textfeilderror) !important;
	}   
</style>
